/**
 * Section: CTA Banner Kinetic Word-by-Word Reveal & 3D Tilt Engine (custom-cta-banner.js)
 */

(function () {
  'use strict';

  function setupWordReveal(banner) {
    const headline = banner.querySelector('.juli-cta-headline');
    if (!headline || headline.dataset.wordsPrepared) return;
    headline.dataset.wordsPrepared = 'true';

    // Recursively split text nodes into words while keeping <em> / <span> intact
    function wrapWords(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        if (!text) return;
        const words = text.split(/(\s+)/);
        const frag = document.createDocumentFragment();

        words.forEach((w) => {
          if (w.length === 0) return;
          if (/^\s+$/.test(w)) {
            frag.appendChild(document.createTextNode(w));
          } else {
            const wrap = document.createElement('span');
            wrap.className = 'juli-cta-word-wrap';
            const inner = document.createElement('span');
            inner.className = 'juli-cta-word';
            inner.textContent = w;
            wrap.appendChild(inner);
            frag.appendChild(wrap);
          }
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.tagName && node.tagName.toLowerCase() === 'br') {
          return;
        }
        Array.from(node.childNodes).forEach(wrapWords);
      }
    }

    Array.from(headline.childNodes).forEach(wrapWords);
    banner.classList.add('has-split-words');

    // Assign staggered animation delays
    const words = headline.querySelectorAll('.juli-cta-word');
    words.forEach((word, index) => {
      word.style.transitionDelay = `${0.22 + index * 0.055}s`;
    });
  }

  function init3DTilt(banner) {
    const icon = banner.querySelector('.juli-cta-app-icon');
    if (!icon || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let rafId = null;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    function renderTilt() {
      currentX += (targetX - currentX) * 0.1;
      currentY += (targetY - currentY) * 0.1;

      if (banner.classList.contains('is-inview')) {
        icon.style.transform = `perspective(800px) rotateX(${-currentY}deg) rotateY(${currentX}deg) translateZ(12px)`;
      }

      if (Math.abs(targetX - currentX) > 0.05 || Math.abs(targetY - currentY) > 0.05) {
        rafId = requestAnimationFrame(renderTilt);
      } else {
        rafId = null;
      }
    }

    banner.addEventListener('mousemove', (e) => {
      const rect = banner.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;

      targetX = (x / (rect.width / 2)) * 14;
      targetY = (y / (rect.height / 2)) * 14;

      if (!rafId) {
        rafId = requestAnimationFrame(renderTilt);
      }
    }, { passive: true });

    banner.addEventListener('mouseleave', () => {
      targetX = 0;
      targetY = 0;
      if (!rafId) {
        rafId = requestAnimationFrame(renderTilt);
      }
    });
  }

  function initCtaAnimation() {
    const banner = document.querySelector('.juli-cta-banner-box');
    if (!banner) return;

    setupWordReveal(banner);
    init3DTilt(banner);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              banner.classList.add('is-inview');
              observer.unobserve(banner);
            }
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -50px 0px' }
      );
      observer.observe(banner);
    } else {
      banner.classList.add('is-inview');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCtaAnimation);
  } else {
    initCtaAnimation();
  }
})();
